module.exports = __webpack_public_path__ + "ee0a1163c177fbc8fa38bfcd83132b6b.png";